import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetBillingSummary = (studentId) => {
    const {
        isLoading, data: billingSummary, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/Billing/Summary`],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/Billing/Summary`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
        enabled: !!studentId,
    });

    return {
        isLoading,
        isRefetching,
        billingSummary,
        error,
        refetch,
    };
};
